import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import Share from './Share';
import { ReactComponent as ShareIcon } from './../../../assets/icons/ShereI.svg';
import { makeStyledIcon } from '../../../utils/helpers';
import { shareWithNativeOrPopup } from '../../../utils/nativeShare';
import { useSendStoreLogs } from '../../../hooks/StoreLogs/useSendStoreLogs';

const ShareNavButton = ({ main_url, name, ...sx }) => {
  const { storeLogs: sendLogs } = useSendStoreLogs();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const IconShare = makeStyledIcon(ShareIcon);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = async (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (open) {
      handleClose();
      return;
    }

    const result = await shareWithNativeOrPopup({
      name,
      url: main_url,
      openPopup: () => setAnchorEl(event.currentTarget),
    });

    if (result === 'shared') {
      sendLogs('shares');
    }
  };

  return (
    <>
      <IconButton
        component="span"
        onClick={handleToggle}
        sx={{ cursor: 'pointer', display: 'inline-flex', p: 0, ...sx }}
      >
        <IconShare className="svg" />
      </IconButton>
      <Share
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        main_url={main_url}
        name={name}
      />
    </>
  );
};

export default ShareNavButton;
